import { API } from "../../../../legacy/api";

export const sendAnimationEndEvent = () => {
  API.notify("ticker.animation.end", null);
};
